const pages = new Set(['home','study','audio','stories','stats']);
export function parseRoute(hash, availableIds, selectedId) {
 const raw = String(hash || '').replace(/^#\/?/, '');
 if(raw === 'languages' || (!raw && !availableIds.includes(selectedId))) return {page:'languages'};
 if(!raw) return {languageId:selectedId, page:'home'};
 let parts; try { parts = raw.split('/').map(decodeURIComponent); } catch { return {page:'languages'}; }
 const [languageId, page='home', itemId] = parts;
 if(!availableIds.includes(languageId)) return {page:'languages'};
 if(page&&!pages.has(page)) {
  // #/ja/<track>[/<collection>[/<part>[/<mode>[/<item>]]]]
  const [,trackId,collectionId,partId,mode,contentId]=parts;
  return {languageId,trackId,...(collectionId?{collectionId}:{}),...(partId?{partId}:{}),page:partId?(pages.has(mode)&&mode!=='home'?mode:'part'):'catalog',...(pages.has(mode)&&contentId?{itemId:contentId}:{})};
 }
 return {languageId,page:pages.has(page)?page:'home',itemId:pages.has(page)?itemId:undefined};
}
export const routeHash = (languageId, page='home', itemId) => `#/${encodeURIComponent(languageId)}/${page}${itemId?'/'+encodeURIComponent(itemId):''}`;
export function contentHash(languageId, selection={}, page='part', itemId) {
 const parts=[languageId,selection.trackId,selection.collectionId,selection.partId].filter(Boolean);
 if(page!=='catalog'&&page!=='part')parts.push(page);
 if(itemId)parts.push(itemId);
 return '#/'+parts.map(encodeURIComponent).join('/');
}
export function resumeHash(languageId,last,selection) {
 return contentHash(languageId,{...selection,...Object.fromEntries(['trackId','collectionId','partId'].filter(k=>last?.[k]).map(k=>[k,last[k]]))},last?.page||'study',last?.itemId);
}
